// extracted by mini-css-extract-plugin
module.exports = {"container":"LanguageSelector_container__Mdvxm","optionsContainer":"LanguageSelector_optionsContainer__2Ht6T"};